import React from 'react'
import { Form, Switch } from 'antd'
import { useAssignmentAccess } from '../../../../../../components/access/Access'
import { Perm, State } from '../../../../../../../../constants/assignment-permissions'

const TestIgnoreCase = () => {
    const { hasAccess: hasEditingPermission } = useAssignmentAccess([Perm.CAN_EDIT, State.NOT_PROCESSING, State.NOT_MBA, State.UNPUBLISHED])

    return (
        <Form.Item name='ignoreCase' label='Ignore Case' valuePropName='checked' initialValue={false}>
            <Switch aria-label='Ignore case' disabled={!hasEditingPermission} />
        </Form.Item>
    )
}

export default TestIgnoreCase
